import * as Sentry from '@sentry/react';
import { getRefreshToken, handleGoogleUserClasses, handleGooleClassRoomUserRegistration } from 'store/googleClassRoom/thunks';
import { handleLoginWithToken } from 'store/auth/thunks';
import { storeGoogleEmail, fetchGoogleUserEmail } from './useGoogleAuth';

export const handleGoogleAuthResponse = async ({
    tokenResponse,
    setLoginProcess,
    setAutologinMessage,
    setError,
    setLoading,
    setIsAutoLogin,
    loginWithSchoology,
    dispatch
}) => {
    const hasCode = tokenResponse?.code;
    const hasAccessToken = tokenResponse?.access_token;
    if (!tokenResponse || (!hasCode && !hasAccessToken)) {
        setError('Invalid Google authentication response. Please try again!');
        return;
    }

    try {
        setLoginProcess(true);
        setAutologinMessage('Please wait while auto-login is in progress.');
        setError('Please wait while auto-login is in progress.');
        setLoading(true);
        setIsAutoLogin(true);

        let accessTokenForRegistration;
        if (hasAccessToken) {
            accessTokenForRegistration = tokenResponse.access_token;
        } else {
            const refreshToken = await getRefreshToken(tokenResponse.code);
            if (!refreshToken || !refreshToken.refresh_token) {
                setAutologinMessage('Please wait while the auto-login process is underway.');
                setError('Please wait while the auto-login process is underway.');
                setLoading(false);
                setIsAutoLogin(false);
                return;
            }
            accessTokenForRegistration = refreshToken.access_token;
        }

        const userRegistration = await handleGooleClassRoomUserRegistration(accessTokenForRegistration);

        let userEmail = userRegistration?.data?.email ?? userRegistration?.email;
        if (!userEmail) {
            userEmail = await fetchGoogleUserEmail(accessTokenForRegistration);
        }
        if (userEmail) {
            storeGoogleEmail(userEmail);
        }

        if (userRegistration?.error) {
            setAutologinMessage(userRegistration.error);
            setError(userRegistration.error);
            setLoading(false);
            setIsAutoLogin(false);
            return;
        }

        if (!userRegistration?.id || !userRegistration?.token || !dispatch) {
            setAutologinMessage('User registration failed. Please contact support for assistance.');
            setError('User registration failed. Please contact support for assistance.');
            setLoading(false);
            setIsAutoLogin(false);
            return;
        }

        setAutologinMessage('User data fetched successfully. Awaiting class synchronization…');

        try {
            const googleId = userRegistration.data?.googleId;
            if (googleId) {
                await handleGoogleUserClasses(googleId);
            }
        } catch (syncError) {
            Sentry.captureException(`Google Classroom sync error: ${syncError}`);
        }

        setAutologinMessage('Signing you in…');
        const result = await dispatch(handleLoginWithToken(userRegistration.token));
        if (!result || !result.isSignedIn) {
            setAutologinMessage('Authentication failed. Please try login again!');
            setError('Authentication failed. Please try login again!');
            setLoading(false);
            setIsAutoLogin(false);
            return;
        }

        const userData = userRegistration.data
            ? { ...userRegistration.data, username: result.username }
            : { username: result.username };
        await loginWithSchoology(userData);
    } catch (error) {
        Sentry.captureException(`Google authentication error: ${error}`);
        setError('Google authentication failed. Please try login again!');
    } finally {
        setLoginProcess(false);
        setLoading(false);
        setIsAutoLogin(false);
    }
};
